// frontend/src/components/common/Button.jsx
import { Link } from "react-router-dom";
import "./Button.css";

/**
 * Button
 * variant: primary | secondary | ghost | danger   ("default" is an alias of secondary)
 * size:    sm | md | lg
 * loading: shows a spinner and disables the button
 * to:      renders a react-router <Link>; href renders an <a>
 * icon / iconRight: optional leading / trailing nodes
 */
export default function Button({
  children,
  variant = "secondary",
  size = "md",
  icon,
  iconRight,
  loading = false,
  disabled = false,
  fullWidth = false,
  to,
  href,
  className = "",
  type,
  ref,
  ...props
}) {
  const v = variant === "default" ? "secondary" : variant;
  const cls = [
    "btn",
    `btn--${v}`,
    `btn--${size}`,
    fullWidth && "btn--full",
    loading && "btn--loading",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const content = (
    <>
      {loading && <span className="btn__spinner" aria-hidden="true" />}
      {!loading && icon && <span className="btn__icon">{icon}</span>}
      {children != null && children !== false && <span className="btn__label">{children}</span>}
      {!loading && iconRight && <span className="btn__icon btn__icon--right">{iconRight}</span>}
    </>
  );

  if (to && !disabled) {
    return (
      <Link ref={ref} to={to} className={cls} {...props}>
        {content}
      </Link>
    );
  }
  if (href && !disabled) {
    return (
      <a ref={ref} href={href} className={cls} {...props}>
        {content}
      </a>
    );
  }

  return (
    <button
      ref={ref}
      type={type || "button"}
      className={cls}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...props}
    >
      {content}
    </button>
  );
}
